import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const SchoolStrength = () => {
  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management",
      link: "",
      subMenu: [
        { label: "Director's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ],
    },

    { label: "International Collaborations", link: "/partnership" },
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

{
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/staff.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="School Strength 2022-23"
                breadEnd="School Strength "
                breadMid="School Strength"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div class="table-responsive content font-normal">
                <table className="table-view light" border="1" width="100%">
                  <tbody>
                    <tr>
                      <th>GRADE</th>
                      <th>TOTAL STRENGTH</th>
                    </tr>
                    <tr>
                      <td>Pre-Nursery </td>
                      <td>22</td>
                    </tr>
                    <tr>
                      <td>Nursery </td>
                      <td>192</td>
                    </tr>
                    <tr>
                      <td>Prep</td>
                      <td>206</td>
                    </tr>
                    <tr>
                      <td>I</td>
                      <td> 219</td>
                    </tr>
                    <tr>
                      <td>II </td>
                      <td>208</td>
                    </tr>
                    <tr>
                      <td>III </td>
                      <td>211</td>
                    </tr>
                    <tr>
                      <td>IV </td>
                      <td>208</td>
                    </tr>
                    <tr>
                      <td>V</td>
                      <td> 214</td>
                    </tr>
                    <tr>
                      <td>VI</td>
                      <td> 208</td>
                    </tr>
                    <tr>
                      <td>VII</td>
                      <td> 210</td>
                    </tr>
                    <tr>
                      <td>VIII</td>
                      <td>207</td>
                    </tr>
                    <tr>
                      <td>IX</td>
                      <td> 218</td>
                    </tr>
                    <tr>
                      <td>X</td>
                      <td>223</td>
                    </tr>
                    <tr>
                      <td>XI</td>
                      <td>146</td>
                    </tr>
                    <tr>
                      <td>XII</td>
                      <td>148</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default SchoolStrength;
